import React, { Component } from "react";
import MainLayout from "../../components/layouts/main";
import Constants from "../../data/constants";
import PopupManager from "../../managers/PopupManager";
import {
  Button,
  Row,
  Col,
  message,
  Cascader,
  Space,
  Input,
  Tooltip,
  Switch,
  Popover,
  Drawer,
} from "antd";
import { connect } from "react-redux";
import {
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectPage,
} from "../../actions";
import { Container } from "react-smooth-dnd";
import DroppablePlaylistMedias from "../../components/views/DroppablePlaylistMedias";
import BrandFileListView from "../../components/views/BrandFileListView";
import PlaylistSelectors from "../../components/PlaylistSelectors";
import LayoutSlotsSelector from "../../components/views/LayoutSlotsSelector";
import PlaylistNotLinkView from "../../components/views/PlaylistNotLinkView";
import DropZoneContainer from "../../components/views/DropZoneContainer";
import {
  InfoCircleFilled,
  ClockCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import PushTimePicker from "../../components/PushTimePicker";
import moment from "moment";
import PermissionManager from "../../managers/PermissionManager";
import useFolderFileStore from "../../store/folderFileStore";
import { Layers, FolderOpen, LayoutGrid } from "lucide-react";
import { THEME_PALLETE } from "../../Theme";

const inputformat = "HH:mm:ss";
const format = "HH:mm";
// import
class TimelineContentPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timelineData: null,
      selectedSlotID: -1,
      currentLayout: null,
      currentPlaylistSlotID: -1,
      mediaSearchWord: "",
      startplaytime: "",
      selectedFolderID: useFolderFileStore.getState().selectedFolderID,
      libraryDrawerOpen: false,
      channelDrawerOpen: false,
      playlistRefreshKey: 0,
    };

    this.reloadFileDatas = () => {};
    this.brandFileListRef = React.createRef();
    this.droppablePlaylistRef = React.createRef();
  }

  componentDidMount() {
    const { selectedTimeline = null } = this.props;
    useFolderFileStore.getState().setSelectedFolderID(null);
    // console.log(JSON.stringify(this.props))
    if (selectedTimeline) {
      this.prepareTimelineData(selectedTimeline);
    }

    this.unsubscribeFolder = useFolderFileStore.subscribe(
      (state) => state.selectedFolderID,
      (selectedFolderID) => {
        this.setState({ selectedFolderID });
      },
    );

    this.setState({ mediaSearchWord: "" });
    // this.reloadTimeline();
  }

  componentWillUnmount() {
    if (this.unsubscribeFolder) {
      this.unsubscribeFolder();
    }
  }

  reloadTimeline = () => {
    const { requestServerGet, userdata, selectedTimeline } = this.props;

    if (!selectedTimeline) return;

    requestServerGet(
      "get_timelines",
      {
        brandid: selectedTimeline.BrandID,
        campaignid: selectedTimeline.CampaignID,
        timelineid: selectedTimeline.TimelineID,
      },
      null,
      (response) => {
        // console.log(JSON.stringify(response.data))

        this.setState({ timelineDatas: response.data });

        if (!response.data.length) return;
        var loadedTimeline = response.data[0];
        this.prepareTimelineData(loadedTimeline);
      },
      userdata.token,
    );
  };

  componentDidUpdate(prevProps) {
    if (
      "selectedTimeline" in this.props &&
      this.props.selectedTimeline !== prevProps.selectedTimeline
    ) {
      const { selectedTimeline = null } = this.props;

      if (selectedTimeline) {
        this.prepareTimelineData(selectedTimeline);
      }
    }
  }

  prepareTimelineData = (timelineData) => {
    const { Timelinelayouts = null } = timelineData;
    var selectedSlotID = this.state.selectedSlotID;

    const TTLO = Timelinelayouts[0];

    if (Timelinelayouts) {
      const { Layout = {}, Channels = "{}" } = TTLO;
      TTLO.layoutJSON = JSON.parse(Layout);
      TTLO.channelJSON = JSON.parse(Channels);

      var slots = TTLO.layoutJSON.slots;

      if (!slots) {
        TTLO.layoutJSON.slots = [];
        slots = [];
      }
      if (slots.length > 0) {
        slots.forEach((slot) => {
          if (!(slot.slot_id in TTLO.channelJSON)) {
            TTLO.channelJSON[slot.slot_id] = -1;
          }
        });
      }

      timelineData.Timelinelayouts = TTLO;

      if (
        slots.length &&
        !slots.some((slot) => {
          return slot.slot_id === selectedSlotID;
        })
      ) {
        selectedSlotID = slots[0].slot_id;
      }
    }
    // console.log("prepareTimelineData " + JSON.stringify(timelineData))

    this.setState(
      { timelineData: timelineData, selectedSlotID: selectedSlotID },
      () => {
        // this.prepareTimelineData();
      },
    );
  };
  // prepareTimelineData = () => {
  //     if (this.state.selectedSlotID === -1) {

  //         const { timelineData = null } = this.state;

  //         if (timelineData) {
  //             const { Timelinelayouts } = timelineData

  //             if (!Timelinelayouts)
  //                 return

  //             const { Layout = null, Channels = "[]" } = Timelinelayouts;
  //             if (Layout) {
  //                 const layoutJSON = JSON.parse(Layout);

  //                 const slots = layoutJSON.slots;
  //                 if (slots.length > 0) {

  //                     if (Channels) {
  //                         const channelJSON = JSON.parse(Channels);

  //                         slots.forEach(slot => {
  //                             if (!slot.slot_id in channelJSON) {
  //                                 channelJSON[slot.slot_id] = -1
  //                             }
  //                         });

  //                         this.setState({ currentLayout: layoutJSON, selectedSlotID: slots[0].slot_id, currentChannels: channelJSON })
  //                     }
  //                     else {
  //                         this.setState({ currentLayout: layoutJSON, selectedSlotID: slots[0].slot_id, currentChannels: [] })
  //                     }
  //                 }

  //                 this.setState({ currentLayout: layoutJSON })

  //             }
  //             else {

  //             }
  //         }
  //     }
  // }

  onPlaylistChanged = (value, selectedOptions) => {};

  assignPlaylistIDToCurrentSlot = (playlistID) => {
    const newTimelineData = { ...this.state.timelineData };
    newTimelineData.Timelinelayouts.layoutJSON.slots.forEach((slot) => {
      if (this.state.selectedSlotID === slot.slot_id) {
        newTimelineData.Timelinelayouts.channelJSON[slot.slot_id] = playlistID;
        // console.log("before channel change " + JSON.stringify(newTimelineData.Timelinelayouts.channelJSON))
      }
    });

    this.setState({ timelineData: newTimelineData }, () => {
      this.onChannelsUpdated();
    });
  };

  onChannelsUpdated = () => {
    if (!this.state.timelineData) return;
    const { requestServerPost, usertoken, selectedBrandData } = this.props;
    var params = new FormData();

    // console.log("onChannelsUpdated" + JSON.stringify(this.state.timelineData.Timelinelayouts.channelJSON))
    params.append("brandid", selectedBrandData.BrandID);
    params.append("duration", this.state.timelineData.Timelinelayouts.Duration);
    params.append(
      "startplaytime",
      this.state.timelineData.Timelinelayouts.StartPlayTime
        ? this.state.timelineData.Timelinelayouts.StartPlayTime
        : "",
    );
    params.append(
      "timelinelayoutid",
      this.state.timelineData.Timelinelayouts.TLLID,
    );
    params.append(
      "channels",
      JSON.stringify(this.state.timelineData.Timelinelayouts.channelJSON),
    );

    requestServerPost(
      "update_timelinelayout",
      params,
      {},
      (response) => {},
      usertoken,
    );
  };

  onLayoutUpdated = () => {
    this.reloadTimeline();
  };

  onFilesUploaded = () => {
    if (this.reloadFileDatas) {
      this.reloadFileDatas();
    }
  };

  handleQuickAddMedia = (fileData) => {
    const { requestServerPost, usertoken, selectedBrandData } = this.props;
    const { timelineData, selectedSlotID } = this.state;
    if (!timelineData || !selectedBrandData || !fileData) return;
    const playlistID = timelineData.Timelinelayouts.channelJSON[selectedSlotID];
    if (!playlistID || playlistID === -1) return;

    const duration = fileData.FileDuration || fileData.Duration || 30;
    requestServerPost(
      "create_media",
      {
        playlistid: playlistID,
        brandid: selectedBrandData.BrandID,
        medianame: fileData.FileName,
        startat: 0,
        duration: parseFloat(duration),
        fileid: fileData.FileID,
        scale: "fill",
        muted: 0,
        startdate: "",
        enddate: "",
      },
      {},
      () => {
        message.success(`Added "${fileData.FileName}" to playlist`);
        this.setState((s) => ({
          playlistRefreshKey: s.playlistRefreshKey + 1,
        }));
      },
      usertoken,
      {},
      () => message.error(`Failed to add "${fileData.FileName}"`),
    );
  };

  handleQuickAddWidget = (widgetData) => {
    const { requestServerPost, usertoken, selectedBrandData } = this.props;
    const { timelineData, selectedSlotID } = this.state;
    if (!timelineData || !selectedBrandData || !widgetData) return;
    const playlistID = timelineData.Timelinelayouts.channelJSON[selectedSlotID];
    if (!playlistID || playlistID === -1) return;

    requestServerPost(
      "create_media",
      {
        playlistid: playlistID,
        brandid: selectedBrandData.BrandID,
        medianame: widgetData.WidgetInstanceName,
        mediatype: "Widget",
        startat: 0,
        duration: 30,
        widgetinstanceid: widgetData.WidgetInstanceID,
        scale: "fit",
        startdate: "",
        enddate: "",
      },
      {},
      () => {
        message.success(`Added "${widgetData.WidgetInstanceName}" to playlist`);
        this.setState((s) => ({
          playlistRefreshKey: s.playlistRefreshKey + 1,
        }));
      },
      usertoken,
      {},
      () => message.error(`Failed to add "${widgetData.WidgetInstanceName}"`),
    );
  };

  onSyncChanged = (checked) => {
    if (checked) {
      this.state.timelineData.Timelinelayouts.StartPlayTime = "00:00:00";
    } else {
      this.state.timelineData.Timelinelayouts.StartPlayTime = "";
    }

    this.setState(
      {
        startplaytime: this.state.timelineData.Timelinelayouts.StartPlayTime,
        timelineData: this.state.timelineData,
      },
      this.onChannelsUpdated,
    );
  };

  onStartplayTimeChanged = (moment) => {
    if (!moment) return;
    // console.log("onStartplayTimeChanged " + moment.format(inputformat))
    moment.second(0);

    this.state.timelineData.Timelinelayouts.StartPlayTime =
      moment.format(inputformat);

    this.setState(
      {
        startplaytime: this.state.timelineData.Timelinelayouts.StartPlayTime,
        timelineData: this.state.timelineData,
      },
      this.onChannelsUpdated,
    );
  };

  render() {
    const {
      onBackClicked = () => {},
      preventDefaultStepBack = false,
      selectedBrandData,
      selectedCampaign,
      selectedTimeline,
      localStepBack = () => {},
    } = this.props;
    const { timelineData } = this.state;

    const createPlaylistPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_PLAYLIST,
      PermissionManager.PERMISSION_TYPE_CREATE,
    );
    const editPlaylistPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_PLAYLIST,
      PermissionManager.PERMISSION_TYPE_EDIT,
    );
    const editCampaignPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_CAMPAIGN,
      PermissionManager.PERMISSION_TYPE_EDIT,
    );

    if (!timelineData) return null;
    const renderTimelineName = timelineData
      ? this.state.timelineData.TimelineName.toLocaleUpperCase()
      : "";

    // console.log(" this.state.timelineData " + JSON.stringify(this.state.timelineData))
    if (!timelineData) return null;

    // console.log("this.state.selectedSlotID " + this.state.selectedSlotID)
    // console.log(JSON.stringify(timelineData.Timelinelayouts.channelJSON))
    // console.log("new playlist id " + timelineData.Timelinelayouts.channelJSON[this.state.selectedSlotID])
    const slotLabel = this.state.selectedSlotID
      ? this.state.selectedSlotID.replace(/_/g, "")
      : "";
    const isSynced =
      this.state.timelineData.Timelinelayouts.StartPlayTime !== "";
    const playlistLinked =
      timelineData.Timelinelayouts.channelJSON[this.state.selectedSlotID] !==
      -1;

    return (
      <MainLayout
        renderBreadCrumb={() => [
          <span
            onClick={() => localStepBack("campaign")}
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: "#64748b",
              padding: "4px 8px",
              lineHeight: "22px",
              cursor: "pointer",
            }}
          >
            Schedule
          </span>,
          selectedCampaign
            ? [
                "/",
                <span
                  onClick={() => localStepBack("timeline")}
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#64748b",
                    padding: "4px 8px",
                    lineHeight: "22px",
                    cursor: "pointer",
                  }}
                >
                  {selectedCampaign.CampaignName}
                </span>,
              ]
            : null,
          selectedTimeline
            ? [
                "/",
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#94a3b8",
                    padding: "4px 8px",
                    lineHeight: "22px",
                  }}
                >
                  {selectedTimeline.TimelineName}
                </span>,
              ]
            : null,
        ]}
        onBackClicked={onBackClicked}
        preventDefaultStepBack={preventDefaultStepBack}
        id={Constants.CAMPAIGN_PAGE}
        ignorPadding={true}
      >
        {/* Lock page to viewport height (minus top bars) so only inner areas scroll */}
        <div
          style={{
            padding: 20,
            height: "calc(100vh - 112px)",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
          <Row gutter={[16, 0]} style={{ height: "100%" }}>
            {/* ── Left: main content ── */}
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={19}
              xl={19}
              style={{
                padding: 0,
                display: "flex",
                flexDirection: "column",
                height: "100%",
                minWidth: 0,
                overflow: "hidden",
              }}
            >
              {/* Page header — same style as Playlist */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  background: THEME_PALLETE.bgCard,
                  borderRadius: 16,
                  padding: "20px 24px",
                  border: `1px solid ${THEME_PALLETE.border}`,
                  marginBottom: 16,
                  boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                  gap: 16,
                  flexWrap: "wrap",
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 16,
                    minWidth: 0,
                    flex: 1,
                  }}
                >
                  <div
                    style={{
                      width: 52,
                      height: 52,
                      borderRadius: 14,
                      background: THEME_PALLETE.gradientBrand,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Layers size={26} color="#fff" />
                  </div>
                  <div style={{ minWidth: 0 }}>
                    <div
                      style={{
                        fontSize: 22,
                        fontWeight: 800,
                        color: THEME_PALLETE.textPrimary,
                        letterSpacing: "-0.02em",
                        lineHeight: 1.2,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {renderTimelineName} : {slotLabel}
                    </div>
                    {selectedBrandData && (
                      <div
                        style={{
                          fontSize: 13,
                          color: THEME_PALLETE.textSecondary,
                          marginTop: 4,
                        }}
                      >
                        {selectedBrandData.BrandName}
                      </div>
                    )}
                  </div>
                </div>

                {/* Right controls */}
                <div
                  className="timeline-header-controls"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    flexWrap: "wrap",
                  }}
                >
                  {/* PLAY MODE */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 4,
                      padding: "8px 14px",
                      borderRadius: 12,
                      border: `1px solid ${THEME_PALLETE.border}`,
                      background: THEME_PALLETE.bgSection,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        fontSize: 11,
                        fontWeight: 600,
                        color: THEME_PALLETE.textSecondary,
                        letterSpacing: "0.06em",
                        textTransform: "uppercase",
                      }}
                    >
                      PLAY MODE
                      <Popover
                        content={
                          <div style={{ width: 250 }}>
                            <p>
                              <strong>Asynchronous:</strong> First content
                              starts playing whenever the player starts
                            </p>
                            <p>
                              <strong>Synchronous:</strong> Content plays as if
                              the first content started at a given start play
                              time (default: 00:00 a.m.)
                            </p>
                          </div>
                        }
                      >
                        <InfoCircleFilled
                          style={{
                            cursor: "pointer",
                            color: THEME_PALLETE.textMuted,
                          }}
                        />
                      </Popover>
                    </div>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 6 }}
                    >
                      <Switch
                        className="playmode-switch"
                        style={{ width: 130 }}
                        disabled={!editCampaignPermission}
                        defaultChecked={isSynced}
                        onChange={this.onSyncChanged}
                        checkedChildren="Synchronous"
                        unCheckedChildren="Asynchronous"
                      />
                      <Popover
                        trigger="click"
                        content={
                          <Space size="small">
                            Start play time:
                            <PushTimePicker
                              allowClear={false}
                              bordered={false}
                              suffixIcon={null}
                              onSelect={this.onStartplayTimeChanged}
                              value={moment(
                                this.state.timelineData.Timelinelayouts
                                  .StartPlayTime,
                                inputformat,
                              )}
                              defaultValue={moment(
                                this.state.timelineData.Timelinelayouts
                                  .StartPlayTime,
                                inputformat,
                              )}
                              format={format}
                            />
                          </Space>
                        }
                      >
                        <ClockCircleOutlined
                          style={{
                            fontSize: 16,
                            color: THEME_PALLETE.primary,
                            cursor: isSynced ? "pointer" : "default",
                            visibility: isSynced ? "visible" : "hidden",
                          }}
                        />
                      </Popover>
                    </div>
                  </div>

                  {/* Current Playlist selector */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 4,
                      padding: "8px 14px",
                      borderRadius: 12,
                      border: `1px solid ${THEME_PALLETE.border}`,
                      background: THEME_PALLETE.bgSection,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 11,
                        fontWeight: 600,
                        color: THEME_PALLETE.textSecondary,
                        letterSpacing: "0.06em",
                        textTransform: "uppercase",
                      }}
                    >
                      Current Playlist
                    </div>
                    <PlaylistSelectors
                      allowCreate={createPlaylistPermission}
                      value={
                        timelineData.Timelinelayouts.channelJSON[
                          this.state.selectedSlotID
                        ]
                      }
                      onSelect={(playlistID) =>
                        this.assignPlaylistIDToCurrentSlot(playlistID)
                      }
                      onPlaylistCreated={(playlistID) =>
                        this.assignPlaylistIDToCurrentSlot(playlistID)
                      }
                      brandid={selectedBrandData.BrandID}
                    />
                  </div>

                  {/* Add Media Files — responsive only, hidden on lg+ */}
                  <Button
                    type="primary"
                    icon={<FolderOpen size={15} />}
                    onClick={() => this.setState({ libraryDrawerOpen: true })}
                    className="hide-on-desktop"
                  >
                    Add Media Files
                  </Button>

                  {/* Channel Slots — responsive only, hidden on lg+ */}
                  <Button
                    type="default"
                    icon={<LayoutGrid size={15} />}
                    onClick={() => this.setState({ channelDrawerOpen: true })}
                    className="hide-on-desktop"
                  >
                    Channel Slots
                  </Button>
                </div>
              </div>

              {/* Media content */}
              <div style={{ flex: 1, overflow: "auto", minHeight: 0 }}>
                {playlistLinked ? (
                  <DropZoneContainer groupName="file">
                    <DroppablePlaylistMedias
                      ref={this.droppablePlaylistRef}
                      refreshKey={this.state.playlistRefreshKey}
                      noDropCreateMessage="You do not have permission to create playlists, please select an existing playlist from dropdown above"
                      noDropEditMessage="You do not have permission to edit playlists"
                      allowDropEdit={editPlaylistPermission}
                      allowDropCreate={createPlaylistPermission}
                      playlistID={
                        timelineData.Timelinelayouts.channelJSON[
                          this.state.selectedSlotID
                        ]
                      }
                    />
                  </DropZoneContainer>
                ) : (
                  <PlaylistNotLinkView
                    noDropCreateMessage="You do not have permission to create a new playlists, please select one from dropdown above"
                    allowDropCreate={createPlaylistPermission}
                    onPlaylistCreated={(playlistID) =>
                      this.assignPlaylistIDToCurrentSlot(playlistID)
                    }
                  />
                )}
              </div>
            </Col>

            {/* ── Right: Channel Slots panel ── */}
            <Col
              xs={0}
              sm={0}
              md={0}
              lg={5}
              xl={5}
              style={{
                background: THEME_PALLETE.bgCard,
                borderRadius: 16,
                border: `1px solid ${THEME_PALLETE.border}`,
                padding: 0,
                overflow: "hidden",
                height: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                {/* Panel header */}
                <div
                  style={{
                    padding: "18px 16px 14px",
                    borderBottom: `1px solid ${THEME_PALLETE.border}`,
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <div
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: "50%",
                      background: THEME_PALLETE.gradientPrimarySoft,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Layers size={15} color={THEME_PALLETE.primary} />
                  </div>
                  <span
                    style={{
                      fontWeight: 600,
                      fontSize: 15,
                      color: THEME_PALLETE.textHeading,
                    }}
                  >
                    Channel Slots
                  </span>
                </div>

                {/* Layout selector */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "16px 0 8px",
                  }}
                >
                  <div
                    style={{
                      width: 180,
                      height: 180,
                      border: `1px solid ${THEME_PALLETE.border}`,
                      borderRadius: 8,
                      overflow: "hidden",
                    }}
                  >
                    <LayoutSlotsSelector
                      onChange={(selectedSlot) =>
                        this.setState({ selectedSlotID: selectedSlot })
                      }
                      selectedSlotID={this.state.selectedSlotID}
                      size={180}
                      layoutData={timelineData.Timelinelayouts.Layout}
                    />
                  </div>
                </div>

                {editCampaignPermission && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      paddingBottom: 12,
                    }}
                  >
                    <Button
                      onClick={() =>
                        PopupManager.launchEditLayoutPopup(
                          timelineData.Timelinelayouts,
                          this.onLayoutUpdated,
                        )
                      }
                      type="default"
                    >
                      Edit Layout
                    </Button>
                  </div>
                )}

                {/* Media library filter */}
                <div style={{ padding: "12px 16px 0" }}>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <div
                      style={{
                        width: 28,
                        height: 28,
                        borderRadius: "50%",
                        background: THEME_PALLETE.gradientPrimarySoft,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <FolderOpen size={13} color={THEME_PALLETE.primary} />
                    </div>
                    <span
                      style={{
                        fontWeight: 600,
                        fontSize: 13,
                        color: THEME_PALLETE.textHeading,
                      }}
                    >
                      Media Files
                    </span>
                    <div style={{ marginLeft: "auto" }}>
                      <Tooltip title="Upload Media">
                        <Button
                          shape="circle"
                          type="primary"
                          size="small"
                          icon={<UploadOutlined />}
                          onClick={() =>
                            PopupManager.launchFileUploader(
                              this.onFilesUploaded,
                              this.state.selectedFolderID,
                            )
                          }
                        />
                      </Tooltip>
                    </div>
                  </div>
                  <Input
                    style={{ marginTop: 8 }}
                    value={this.state.mediaSearchWord}
                    onChange={(e) =>
                      this.setState({ mediaSearchWord: e.target.value })
                    }
                    placeholder="Filter Media Files"
                  />
                </div>
                <div
                  style={{
                    overflow: "auto",
                    marginTop: 8,
                    flex: 1,
                    minHeight: 200,
                  }}
                >
                  <BrandFileListView
                    reloadFunctionMapper={(reloadFN) => {
                      this.reloadFileDatas = reloadFN;
                    }}
                    ref={this.brandFileListRef}
                    filterWord={this.state.mediaSearchWord}
                    onQuickAddMedia={
                      playlistLinked ? this.handleQuickAddMedia : null
                    }
                    onQuickAddWidget={
                      playlistLinked ? this.handleQuickAddWidget : null
                    }
                  />
                </div>
              </div>
            </Col>
          </Row>

          {/* Media Library Drawer — responsive only (small screens) */}
          <Drawer
            title="Media Files"
            placement="bottom"
            height="78vh"
            onClose={() => this.setState({ libraryDrawerOpen: false })}
            open={this.state.libraryDrawerOpen}
            destroyOnClose={false}
            bodyStyle={{ padding: 0 }}
          >
            <div style={{ background: THEME_PALLETE.bgCard, height: "100%" }}>
              {/* Header */}
              <div
                style={{
                  padding: "18px 16px 14px",
                  borderBottom: `1px solid ${THEME_PALLETE.border}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: "50%",
                      background: THEME_PALLETE.gradientPrimarySoft,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <FolderOpen size={15} color={THEME_PALLETE.primary} />
                  </div>
                  <span
                    style={{
                      fontWeight: 600,
                      fontSize: 15,
                      color: THEME_PALLETE.textHeading,
                    }}
                  >
                    Media Files
                  </span>
                </div>
                <Tooltip title="Upload Media">
                  <Button
                    shape="circle"
                    type="primary"
                    size="small"
                    icon={<UploadOutlined />}
                    onClick={() =>
                      PopupManager.launchFileUploader(
                        this.onFilesUploaded,
                        this.state.selectedFolderID,
                      )
                    }
                  />
                </Tooltip>
              </div>
              {/* Filter */}
              <div style={{ padding: "12px 16px 0" }}>
                <Input
                  value={this.state.mediaSearchWord}
                  onChange={(e) =>
                    this.setState({ mediaSearchWord: e.target.value })
                  }
                  placeholder="Filter media..."
                />
              </div>
              {/* File list */}
              <div
                style={{
                  maxHeight: "calc(78vh - 130px)",
                  overflow: "auto",
                  marginTop: 8,
                }}
              >
                <BrandFileListView
                  reloadFunctionMapper={(reloadFN) => {
                    this.reloadFileDatas = reloadFN;
                  }}
                  ref={this.brandFileListRef}
                  disableDrag
                  filterWord={this.state.mediaSearchWord}
                  onQuickAddMedia={
                    playlistLinked ? this.handleQuickAddMedia : null
                  }
                  onQuickAddWidget={
                    playlistLinked ? this.handleQuickAddWidget : null
                  }
                />
              </div>
            </div>
          </Drawer>

          {/* Channel Slots Drawer — responsive only (small screens) */}
          <Drawer
            title="Channel Slots"
            placement="bottom"
            height="auto"
            onClose={() => this.setState({ channelDrawerOpen: false })}
            open={this.state.channelDrawerOpen}
            bodyStyle={{ padding: "16px" }}
          >
            {/* Layout selector */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 16,
              }}
            >
              <div
                style={{
                  width: 180,
                  height: 180,
                  border: `1px solid ${THEME_PALLETE.border}`,
                  borderRadius: 8,
                  overflow: "hidden",
                }}
              >
                <LayoutSlotsSelector
                  onChange={(selectedSlot) =>
                    this.setState({ selectedSlotID: selectedSlot })
                  }
                  selectedSlotID={this.state.selectedSlotID}
                  size={180}
                  layoutData={timelineData.Timelinelayouts.Layout}
                />
              </div>
            </div>
            {editCampaignPermission && (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  onClick={() => {
                    PopupManager.launchEditLayoutPopup(
                      timelineData.Timelinelayouts,
                      this.onLayoutUpdated,
                    );
                    this.setState({ channelDrawerOpen: false });
                  }}
                  type="default"
                >
                  Edit Layout
                </Button>
              </div>
            )}
          </Drawer>
        </div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    globalSearch: state.globalSearch,
    selectedBrandData: state.selectedBrandData,
  };
};

export default connect(mapStateToProps, {
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectPage,
})(TimelineContentPage);
